module.exports = __webpack_public_path__ + "images/emoji/hamster.b1b2501c6af73faac7d7.png";